import { HelixIcon } from '@helix/helix-icon'
import { useSearchParams } from 'react-router-dom'
import { email as EmailIcon } from '@helix/helix-icon/outlined'

function BrokerSignupInstructions() {
  const [searchParams] = useSearchParams()

  const accountName = searchParams.get('account') || 'Nebraska Realty'
  const email =
    searchParams.get('admin_email') || 'marketing@nebraskarealty.com'
  const isNebraskaRealty = accountName === 'Nebraska Realty'

  return (
    <div className="flex min-h-[100dvh] flex-grow flex-col items-center justify-center px-4 py-8">
      <div className="flex max-w-[30rem] flex-col justify-center">
        <div className="flex items-center self-center justify-center gap-2 px-4 py-2 mb-5 font-medium text-yellow-800 border border-yellow-300 border-solid rounded-full w-fit bg-yellow-50">
          <span className="w-2 h-2 bg-yellow-500 rounded-full" />
          <span className="helix-body">Setup required</span>
        </div>
        <h2 className="font-semibold text-center helix-display-small text-brand-dark">
          Your Account isn't set up yet
        </h2>
        <p className="mt-5 text-center mb-7 text-brand-primary">
          To access Cloud CMA, your{' '}
          <span className="capitalize">{accountName}</span> administrator needs
          to add you to the Lone Wolf Platform. Reach out to them and they'll
          get you setup quickly.
        </p>
        <div className="flex flex-col px-6 py-5 border border-solid rounded-md shadow-sm border-brand-mint bg-brand-white">
          {isNebraskaRealty ? (
            <p className="font-medium helix-body text-brand-primary">
              Request your Cloud CMA account through{' '}
              <a
                href="https://realtorresource.info/login"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold underline helix-text-brand hover:no-underline">
                Realtor Resource
              </a>
            </p>
          ) : (
            <>
              <p className="font-medium helix-body text-brand-primary">
                Contact your <span className="capitalize">{accountName}</span>{' '}
                administrator:
              </p>
              <a
                href={`mailto:${email}`}
                className="helix-body mt-2 flex w-fit items-center gap-2.5 rounded-md bg-brand-dark px-5 py-2 font-medium text-white no-underline hover:text-white hover:no-underline">
                <HelixIcon icon={EmailIcon} className="helix-svg-fill--white" />
                <span>{email}</span>
              </a>
            </>
          )}
        </div>
        <div className="w-full my-10 border-b border-gray-300 border-solid" />
        <div className="flex flex-col gap-6">
          <p className="text-sm font-semibold tracking-wide text-gray-500 uppercase helix-body">
            What happens next
          </p>
          <div className="flex gap-4">
            <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 text-sm font-semibold text-white rounded-full bg-brand-dark">
              1
            </div>
            <p className="pt-1 helix-body text-brand-dark">
              Your admin will{' '}
              <span className="font-semibold">
                send you a Platform invitation
              </span>{' '}
              from Lone Wolf to your email address.
            </p>
          </div>
          <div className="flex gap-4">
            <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 text-sm font-semibold text-white rounded-full bg-brand-dark">
              2
            </div>
            <p className="pt-1 helix-body text-brand-dark">
              <span className="font-semibold">Accept the invitation</span> and
              complete your Lone Wolf account setup — this is a one-time step.
            </p>
          </div>
          <div className="flex gap-4">
            <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 text-sm font-semibold text-white rounded-full bg-brand-dark">
              3
            </div>
            <p className="pt-1 helix-body text-brand-dark">
              Return to your intranet and{' '}
              <span className="font-semibold">log in via SSO</span> as normal —
              you're all set.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BrokerSignupInstructions
